module.exports = __webpack_public_path__ + "img/premium_d_dark.28be9473.svg";